import axiosInstance from "../Common/Axios/axiosInstance";
import API from "../Common/Endpoint/serviceConstrants";

export const callClientCappingGetApi = async (payload) => {
  const { data = {} } = await axiosInstance.get(API.suppliercapping, {
    params: {
      "Client-Id": payload,
    },
  });
  return data;
};
